import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';
import * as Sentry from '@sentry/capacitor';

export const sentryHttpInterceptor: HttpInterceptorFn = (req, next) =>
  next(req).pipe(
    catchError((err: HttpErrorResponse) => {
      if (err.status >= 500) {
        Sentry.captureException(err, {
          tags: { origin: 'backend', http_status: String(err.status) },
          extra: { url: req.url, method: req.method },
        });
      }
      return throwError(() => err);
    })
  );